let topicsSwiper;

function initTopicsSwiper() {
  const breakpoint = window.matchMedia("(min-width: 768px)");

  const enableSwiper = () => {
    if (!topicsSwiper) {
      topicsSwiper = new Swiper(".topics__slider", {
        slidesPerView: 1.2,
        spaceBetween: 20,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          420: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          540: {
            slidesPerView: 2.5,
            spaceBetween: 20,
            centeredSlides: true,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
            centeredSlides: true,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  };

  const disableSwiper = () => {
    if (topicsSwiper) {
      topicsSwiper.destroy(true, true);
      topicsSwiper = undefined;
    }
  };

  const breakpointChecker = () => {
    if (breakpoint.matches) {
      enableSwiper();
    } else {
      disableSwiper();
    }
  };

  breakpoint.addEventListener("change", breakpointChecker);
  breakpointChecker(); // 初期実行
}

initTopicsSwiper();

const lineupSwiper = new Swiper(".lineup__slider", {
  slidesPerView: "auto",
  spaceBetween: 15,
  centeredSlides: false,
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      spaceBetween: 20,
    },
  },
});

const howToSwiper = new Swiper(".howto__slider", {
  slidesPerView: "auto",
  spaceBetween: 16,
  centeredSlides: true,
});

const ideaSwiper = new Swiper(".idea__slider", {
  slidesPerView: "auto",
  spaceBetween: 20,
  centeredSlides: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
});

const reviewSwiper = new Swiper(".review__slider", {
  slidesPerView: "auto",
  spaceBetween: 20,
  centeredSlides: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
});

const magazineSwiper = new Swiper(".magazine__slider", {
  slidesPerView: "auto",
  spaceBetween: 20,
  centeredSlides: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
});
